/**
 * Created by cuppi on 2016/12/7.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const JNetwork_1 = require("./JNetwork");
const JUrlList_1 = require("../unify/JUrlList");
const JDataUnify_1 = require("../unify/JDataUnify");
const JNetworkRoot_1 = require("./JNetworkRoot");
/**
 * 交易接口
 * @memberOf module:network
 */
class JNetworkTrade extends JNetworkRoot_1.default {
    /**
     * 锁座
     * @param type 平台类型
     * @param paras 锁座参数
     * @returns {{terminate, then}|*}
     */
    tradeLockSeat(type, paras) {
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.tradeUrl.jbzLockSeat, Object.assign({ type }, paras)).then(data => {
                resolve(JDataUnify_1.default('tradeUrl.jbzLockSeat', data));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 取消锁座
     * @param orderId 订单Id
     * @returns {{terminate, then}|*}
     */
    tradeCancelLockSeat(orderId) {
        return this.prefixPromise(JUrlList_1.tradeUrl.jbzCancelOrder, { orderId });
    }
    /**
     * 下订单
     * @param type 平台类型
     * @param paras 下订单参数
     * @returns {{terminate, then}|*}
     */
    tradeApplyOrder(type, paras) {
        let inType = JNetwork_1.default.inType;
        if (inType === 'ICBC-APP' || inType === 'SHANGHAI-APP') {
            return new Promise((resolve, reject) => {
                this.prefixPromise(JUrlList_1.tradeUrl.jbzWebAtAppApplyTicket, Object.assign({ type }, paras)).then(data => {
                    resolve(JDataUnify_1.default('tradeUrl.jbzWebAtAppApplyTicket', data));
                }, error => {
                    reject(error);
                });
            });
        }
        return JNetwork_1.default.wrongInType();
    }
    /**
     * 申请预订单
     * @param orderId 订单Id
     * @param payType 支付类型
     * @param prizeIds 待定
     * @param redIds 待定
     * @returns {{terminate, then}|*}
     */
    tradePrePayOrder(orderId, payType, prizeIds, redIds) {
        let inType = JNetwork_1.default.inType;
        if (inType === 'DPIOS' || inType === 'DPANDROID') {
            return this.prefixPromise(JUrlList_1.tradeUrl.jbzAppPrepay, { orderId, payType, prizeIds, redIds });
        }
        if (inType === 'DPWX' || inType === 'DPWEB' || inType === 'PC') {
            return this.prefixPromise(JUrlList_1.tradeUrl.jbzWebPrepay, { orderId, payType, prizeIds, redIds });
        }
        return JNetwork_1.default.wrongInType();
    }
    static tradeLockSeat(type, paras) {
        return this.instance().tradeLockSeat(type, paras);
    }
    static tradeCancelLockSeat(orderId) {
        return this.instance().tradeCancelLockSeat(orderId);
    }
    static tradeApplyOrder(type, paras) {
        return this.instance().tradeApplyOrder(type, paras);
    }
    static tradePrePayOrder(orderId, payType, prizeIds, redIds) {
        return this.instance().tradePrePayOrder(orderId, payType, prizeIds, redIds);
    }
}
exports.default = JNetworkTrade;
